import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import { useLazyRender } from '../hooks/use-lazy-render';
var Overlay = function (_a) {
    var _b = _a.prefixCls, prefixCls = _b === void 0 ? 'pptmui-overlay' : _b, className = _a.className, children = _a.children, style = _a.style, visible = _a.visible, onClick = _a.onClick, _c = _a.transitionName, transitionName = _c === void 0 ? 'pptmui-fade' : _c;
    var lazyRender = useLazyRender(visible);
    var renderOverlayChildren = lazyRender(function () {
        return React.createElement(React.Fragment, null, children);
    });
    var renderTransition = function () {
        var _a;
        var overlayCls = classNames(prefixCls, className, (_a = {},
            _a[prefixCls + "--visible"] = visible,
            _a));
        return (React.createElement(CSSTransition, { classNames: transitionName, in: visible, timeout: 300, unmountOnExit: true },
            React.createElement("div", { className: overlayCls, style: style, onClick: onClick }, renderOverlayChildren())));
    };
    return React.createElement(React.Fragment, null, renderTransition());
};
export default Overlay;
